<script setup>
import Protocol from "@/components/initiativeFiles/Protocol.vue";
import CouncilDecision from "@/components/initiativeFiles/CouncilDecision.vue";
import {ref} from "vue";
import {useStore} from "vuex"; // Import the useStore function
const store = useStore();

const props = defineProps(["show", "close", "board_id"]);

const loading = ref(false);
const showModal = ref(true);
const activeTab = ref("protocol");

const protocolFileUploaded = ()=>{
  this.$emit('protocolFileUploaded')
}
</script>

<template>
  <div v-loading="loading">
    <el-dialog
        v-model="showModal"
        @close="close"
        :fullscreen="store.state.role === 'admin'||store.state.role === 'moderator'"
        title="Хужжатларни юклаш"
        align-center
    >
      <el-tabs v-model="activeTab" class="demo-tabs">
        <el-tab-pane label="Модерация натижалари протоколи" name="protocol">
          <template v-if="activeTab === 'protocol'">
            <Protocol :board_id="board_id" :close="close" @protocolFileUploaded="protocolFileUploaded"/>
          </template>
        </el-tab-pane>
        <el-tab-pane
            label="Ғолиб лойиҳалар юзасидан Кенгаш қарори"
            name="council_decision"
        >
          <template v-if="activeTab === 'council_decision'">
            <CouncilDecision :board_id="board_id" :close="close" type="council-decision"/>
          </template>
        </el-tab-pane>
<!--        <el-tab-pane-->
<!--            label="Буюртмачи тайинлаш ҳужжати"-->
<!--            name="orderer_document_file"-->
<!--        >-->
<!--          <template v-if="activeTab === 'orderer_document_file'">-->
<!--            <CouncilDecision :board_id="board_id" :close="close" type="orderer-document"/>-->
<!--          </template>-->
<!--        </el-tab-pane>-->
      </el-tabs>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss"></style>
